/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Company_Registration_IntroInputs */

const en_company_registration_intro = /** @type {(inputs: Company_Registration_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Would you like to participate as an employer in the Matching Week? Register here.`)
};

const de_company_registration_intro = /** @type {(inputs: Company_Registration_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Möchten Sie als Arbeitgeber an der Matching Week teilnehmen? Dann registrieren Sie sich hier.`)
};

/**
* | output |
* | --- |
* | "Would you like to participate as an employer in the Matching Week? Register here." |
*
* @param {Company_Registration_IntroInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const company_registration_intro = /** @type {((inputs?: Company_Registration_IntroInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Company_Registration_IntroInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_company_registration_intro(inputs)
	return en_company_registration_intro(inputs)
});